// eslint-disable-next-line import/prefer-default-export
export const navigationConfig = Object.freeze({
    competition:'competition',
    merchandising:'merchandising',
    offers:'offers'
})